import { FC, SVGAttributes } from 'react';

const FillCards: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.55292 20.5601L35.5307 12.7956L38.6365 24.3867C38.9224 25.4536 38.2892 26.5503 37.2223 26.8362L12.1082 33.5654C11.0413 33.8513 9.94463 33.2182 9.65875 32.1512L6.55292 20.5601Z"
        fill="#8C929B"
      />
      <path d="M5.77646 17.6623L34.7542 9.89778L35.5957 13.0382L6.61793 20.8028L5.77646 17.6623Z" fill="#383E43" />
      <path
        d="M5.51764 16.6964C5.23175 15.6295 5.86492 14.5328 6.93185 14.2469L32.0459 7.51764C33.1129 7.23175 34.2095 7.86492 34.4954 8.93185L34.7542 9.89778L5.77646 17.6623L5.51764 16.6964Z"
        fill="#8C929B"
      />
      <path
        d="M14 19C12.8954 19 12 19.8954 12 21V37C12 38.1046 12.8954 39 14 39H40C41.1046 39 42 38.1046 42 37V21C42 19.8954 41.1046 19 40 19H14Z"
        fill="#A3C9FF"
      />
      <rect x="15" y="27" width="5" height="4" rx="0.5" fill="white" />
    </svg>
  );
};

export default FillCards;
